import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from 'semantic-ui-react'

const ReorderTool = (props) => {
    return (
        <Grid className="reorderTool">
            <Grid.Row>
                <Grid.Column floated="left" width={4}>
                    <i className="icon-arrow-up icon clickable" onClick={props.upHandler}/> <i className="icon-arrow-down icon clickable"
                                                                                     onClick={props.downHandler}/>
                </Grid.Column>
                <Grid.Column floated="right" width={3}>
                    {props.clearHandler !== null &&
                    <i onClick={props.clearHandler} className="icon-cross icon clickable"/>
                    }
                </Grid.Column>
            </Grid.Row>
        </Grid>
    )
};

ReorderTool.propTypes = {
    upHandler: PropTypes.func,
    downHandler: PropTypes.func,
    clearHandler: PropTypes.func
};

ReorderTool.defaultProps = {
    upHandler: () => {
    },
    downHandler: () => {
    },
    clearHandler: null
};

export default ReorderTool;


// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/ReorderTool.js